import React from 'react';
import { Modal } from 'shared/ui/Modal/Modal';
import { FaceFrownIcon } from '@heroicons/react/24/outline';
import { Button } from 'shared/ui/Button/Button';

export const FailModal: React.FC<{
  show: boolean;
  onClose: () => void;
}> = ({ show, onClose }) => {
  return (
    <Modal popup dismissible show={show} onClose={onClose}>
      <Modal.Header className="dark:border-slate-600"></Modal.Header>

      <Modal.Body>
        <div className="text-center">
          <FaceFrownIcon color="#e25757" className="inline h-16 w-16" />
          <div className="my-6 space-y-4 text-center">
            <h3 className="text-2xl font-semibold leading-6 text-white">
              Invoice Creation Not Complete
            </h3>

            <p className="text-base text-slate-300">
              Something went wrong. We will look into this with our utmost
              priority. Should you have any questions, please contact our CEO at
              pavel@getfractal.xyz.
            </p>

            <div className="flex justify-center p-5">
              <div className="px-2">
                <Button color="indigo" onClick={onClose}>
                  Continue to App
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
